var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var truncateString = function (str, num) {
    return str && str.length > num ? str.slice(0, num).concat('...') : str;
};
export var capitalize = function (string) {
    return "" + string.charAt(0).toUpperCase() + string.slice(1);
};
export var getObjectValueByString = function (obj, path) {
    return path.split('.').reduce(function (acc, part) { return acc && acc[part]; }, obj);
};
export var callAllEventHandlers = function () {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return fns.some(function (fn) { return fn && fn.apply(void 0, __spreadArrays([event], args)); });
    };
};
export var splitObjectIntoTwo = function (obj, fields) {
    if (fields === void 0) { fields = []; }
    var mainObj = {};
    var extractedObj = {};
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (!fields.includes(key)) {
            mainObj[key] = obj[key];
        }
        if (fields.includes(key)) {
            extractedObj[key] = obj[key];
        }
    }
    return [mainObj, extractedObj];
};
export function removeFromTabFlowIfMatches(current, match) {
    return current.matches(match) ? -1 : null;
}
export function concatenateStrings(strings) {
    return strings.filter(Boolean).join(' ');
}
//# sourceMappingURL=utils.js.map